Vue.component("delete-menu-component", require("./Delete.vue").default);
Vue.component("edit-menu-component", require("./Edit.vue").default);
Vue.component("create-menu-component", require("./Create.vue").default);
Vue.component("manage-menu-component", require("./Index.vue").default);

